import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { cyan500, pinkA200, cyan700, grey400, grey100, grey500 } from 'material-ui/styles/colors';

const muiTheme = getMuiTheme({
  fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  palette: {
    textColor: 'rgba(0, 0, 0, 0.84)',
  },
  raisedButton: {
    primaryColor: pinkA200,
    secondaryColor: cyan500,
  },
  flatButton: {
    primaryTextColor: pinkA200,
    secondaryTextColor: cyan500,
  },
});

export default muiTheme;



// WEBPACK FOOTER //
// ./src/app/utils/muiTheme.js